import { useBrandCart } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useBrandCart";
import { IBrandCartV2 } from "@faire/web-api--source/faire/carts/IBrandCartV2";
import { useMemo } from "react";

import { BRAND_CART_STALE_TIME_MS } from "./consts";

export const useCartBrand = (
  brandToken: string,
  staleTime: number = BRAND_CART_STALE_TIME_MS
): IBrandCartV2 | undefined => {
  const { data: brandCart } = useBrandCart(brandToken, staleTime);
  const cartBrand = useMemo(() => {
    return brandCart?.brand_carts?.find(
      (cart) => cart.brand_token === brandToken
    );
  }, [brandCart, brandToken]);
  return cartBrand;
};
